// Platform feature flags (auth-service /platform/feature-flags via the gateway).
// Global on/off + gradual rollout + per-tenant overrides. Platform-scoped.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);
const B = `${API_V1}/platform/feature-flags`;

export interface FeatureFlag {
  id: string;
  key: string;
  description?: string | null;
  enabled: boolean;
  rolloutPercentage: number;
  overrideCount: number;
  updatedAt?: string;
}
export interface FlagOverride {
  id: string;
  tenantId: string;
  enabled: boolean;
  updatedBy?: string | null;
  createdAt?: string;
}
export interface FlagResolution {
  key: string;
  enabled: boolean;
  reason: string;
}

export const listFlags = () => axios.get<FeatureFlag[]>(B).then((r) => r.data);
export const createFlag = (body: { key: string; description?: string; enabled?: boolean; rolloutPercentage?: number }) =>
  axios.post<FeatureFlag>(B, body).then((r) => r.data);
export const updateFlag = (id: string, body: { description?: string; enabled?: boolean; rolloutPercentage?: number }) =>
  axios.patch<FeatureFlag>(`${B}/${id}`, body).then((r) => r.data);
export const deleteFlag = (id: string) => axios.delete(`${B}/${id}`).then((r) => r.data);

export const listOverrides = (id: string) => axios.get<FlagOverride[]>(`${B}/${id}/overrides`).then((r) => r.data);
export const setOverride = (id: string, tenantId: string, enabled: boolean) =>
  axios.put(`${B}/${id}/overrides/${tenantId}`, { enabled }).then((r) => r.data);
export const clearOverride = (id: string, tenantId: string) =>
  axios.delete(`${B}/${id}/overrides/${tenantId}`).then((r) => r.data);

export const evaluateFlag = (id: string, tenantId: string) =>
  axios.get<FlagResolution>(`${B}/${id}/evaluate`, { params: { tenantId } }).then((r) => r.data);
